/* Cloudflare turnstile */

const siteKeys = {
    host_signup: '0x4AAAAAAAB99Lv5fZRZSFsw',
    estab_email_share: '0x4AAAAAAA9v8yJH3IsRt7Al',
    booking_form: '0x4AAAAAAB7UzpwzPkuDiCll'
};

function cloudflare_turnstile(formName) {
    if (!siteKeys.hasOwnProperty(formName) && !window.tg.is_vm) {
        throw new Error('Invalid site key type provided.');
    }

    let cf_sitekey = siteKeys[formName];

    // Use testing sitekey for VM's due to domain restrictions
    if (window.tg.is_vm) {
        cf_sitekey = '3x00000000000000000000FF'; // always visible key
    }

    try {
        const cfTurnstileDiv = document.querySelector('#cf-turnstile');

        // Check if widget already exists and reset it before executing
        if (cfTurnstileDiv && cfTurnstileDiv.children.length > 0) {
            try {
                turnstile.reset('#cf-turnstile');
            } catch (resetError) {
                console.warn('Failed to reset turnstile, will try to execute anyway:', resetError);
            }
        }

        turnstile.execute('#cf-turnstile', {
            sitekey: cf_sitekey,
            theme: 'light',
            size: 'flexible',
            appearance: 'interaction-only',
        });
    } catch (e) {
        // If the turnstile script fails to load, we need fail safely
        const cfTurnstileDiv = document.querySelector('#cf-turnstile');

        if (cfTurnstileDiv) {
            // Create a new input element
            var hiddenInput = document.createElement("input");
            hiddenInput.type = "hidden";
            hiddenInput.name = "cf-turnstile-response";

            // Add a token to safely fail and reset
            hiddenInput.value = "dummy";
            cfTurnstileDiv.appendChild(hiddenInput);
        } else {
            console.warn('Turnstile div not found, skipping fallback input creation');
        }
    }
}

// Make function available globally for Vue components
window.cloudflare_turnstile = cloudflare_turnstile;

export { cloudflare_turnstile };
